import {
    Container,
    Flex,
    Box,
    Heading,
    Text,
    IconButton,
    Button,
    VStack,
    HStack,
    Wrap,
    WrapItem,
    Link
  } from '@chakra-ui/react';
  import {
    MdPhone,
    MdEmail,
    MdLocationOn
  } from 'react-icons/md';
  import { BsGithub, BsLinkedin } from 'react-icons/bs';
  
  export default function Contact() {
    return (
      <Container bg="secondary" id='contact' py={'10px'} maxW="full" mt={'25px'} centerContent overflow="hidden">
        <Flex>
          <Box
            border={'2px solid black'}
            bg="secondary"
            color="text"
            borderRadius="3xl"
            m={{ sm: 5, md: 16, lg: 10 }}
            p={{ sm: 5, md: 5, lg: 5 }}>
            <Box p={4}>
              <Wrap spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}>
                <WrapItem>
                  <Box>
                    <Heading>Contact Me</Heading>
                    <Box py={{ base: 5, sm: 5, md: 5, lg: 5 }}>
                      <VStack pl={0} spacing={2} alignItems="flex-start">
                        <Button
                          id='contact-phone'
                          size="md"
                          height="48px"
                          width="300px"
                          variant="ghost"
                          color="text"
                          _hover={{ border: '2px solid black' }}
                          leftIcon={<MdPhone color="black" size="25px" />}>
                          +91-7588853334
                        </Button>
                        <Button
                          id='contact-email'
                          size="md"
                          height="48px"
                          width="300px"
                          variant="ghost"
                          color="text"
                          _hover={{ border: '2px solid black' }}
                          leftIcon={<MdEmail color="black" size="25px" />}>
                          rutuvikpatil661998@gmail.com
                        </Button>
                        <Button
                          size="md"
                          height="48px"
                          width="300px"
                          variant="ghost"
                          color="text"
                          _hover={{ border: '2px solid black' }}
                          leftIcon={<MdLocationOn color="black" size="25px" />}>
                          Latur, India
                        </Button>
                      </VStack>
                    </Box>
                    <HStack
                      w={'50%'}
                      m="auto"
                    //   mt={{ lg: 5, md: 5 }}
                      spacing={2}
                      px={5}
                      alignItems="center">
                      <Link id='contact-github' isExternal href='https://github.com/RutuvikP'>
                      <IconButton
                        aria-label="github"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: 'black' }}
                        icon={<BsGithub size="32px" />}
                      />
                      </Link>
                      <Link id='contact-linkedin' isExternal href='https://www.linkedin.com/in/rutuvikpatil'>
                      <IconButton
                        aria-label="linkedin"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: 'black' }}
                        icon={<BsLinkedin size="30px" />}
                      />
                      </Link>
                    </HStack>
                  </Box>
                </WrapItem>
              </Wrap>
            </Box>
          </Box>
        </Flex>
        <Text>©️ Copyright 2023 | Designed & Built by Rutuvik Patil</Text>
      </Container>
    );
  }